<template>
  <div>
    <b-row class="cargo-data-row">
      <b-col sm="12" md="5">
        <label>{{ this.label }}</label>
      </b-col>
      <b-col sm="12" md="6">
        <span v-html="getFormattedValue"></span>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "BaseRowDetail",
  props: {
    label: String,
    value: String,
  },
  computed: {
    getFormattedValue() {
      if (!this.value) return "";
      return this.value.toString().replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
  }
};
</script>

<style scoped>
.cargo-data-row span {
  color: #c0c1c2;
}
</style>